import { FC, useContext, useRef} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../ag-grid.css'
import '../../../ag-theme-alpine.css'
import { IAdminTable } from "../../../models/AdminModel"
import { UserContext } from "../../../Redux/UserContext"
import { error, success, warning } from "../../../utils/notifications"
import { ADMIN_PERMISSIONS } from "../../../data/constants"
import { deleteRol } from "../../../services/admin-service"
import { catchResponse } from "../../../utils/helperFunctions"
import { GrEdit } from "react-icons/gr";
import { HiOutlineTrash } from "react-icons/hi2";
import { Tooltip } from 'primereact/tooltip';

export const AdminTable:FC<any> = (props) => {

    const gridRef :any= useRef();

    const {dataTable, handleOpenEditModal, setSelectedUser, flagGlobal, setFlagGlobal, flagAdmin, setFlagAdmin, setValuesPlanta} = props

    const [state] = useContext(UserContext)

    const LinkCellRenderer:FC<any> = (props:any):JSX.Element => {


        const { data } = props

        const handleEditRol = (e:any,params:IAdminTable) => {
            setSelectedUser(params)
            
            let plantas:any = params.id_plants.map((idp:any) => {
                switch(idp) {
                    case 1:
                        return {id:idp,name:"Sanguesa"}
                        
                    case 2:
                        return {id:idp,name:"Briviesca"}
                    case 3:
                        return {id:idp,name:"Miajadas"}
                        
                }
            })
            setValuesPlanta(plantas)
            handleOpenEditModal()
        }

        const handleDeleteRol = async(e:any,params:IAdminTable) => {
            try {
                const res = await deleteRol(params.id_user)
                if(res.status === 200) {
                    const { code, message} = res.data
                    if(code === 200) {
                        success(message)
                        setFlagGlobal(!flagGlobal)
                        setFlagAdmin(!flagAdmin)
                    } else if( code === 600) {
                        error(message)
                    }
                } else {
                    error("Error eliminando el rol del usuario.")
                }
            } catch(err:any) {
                catchResponse(err)
            }
        }
        
        return (
            <button className="paymt__button">
                <Tooltip target=".custom-target-icon"  style={{fontSize:'0.75rem',fontFamily:'var(--roboto-light)'}}/>
                <GrEdit
                    className="custom-target-icon"
                    data-pr-tooltip="Editar permisos"
                    data-pr-position="bottom"
                    style={{fontSize:18, marginRight:'1rem'}} onClick={state?.rol_id !== undefined? ADMIN_PERMISSIONS.U.includes(state?.rol_id)?  (e:any) => handleEditRol(e,data) : () => {warning("No tienes permisos para realizar esta operación")}  : () => {warning("No tienes permisos para realizar esta operación")}} />
                <Tooltip target=".custom-target-icon2" style={{fontSize:'0.75rem',fontFamily:'var(--roboto-light)'}} />
                <HiOutlineTrash 
                    className="custom-target-icon2"
                    data-pr-tooltip="Eliminar permisos"
                    data-pr-position="bottom"
                    style={{fontSize:18}} onClick={state?.rol_id !== undefined? ADMIN_PERMISSIONS.D.includes(state?.rol_id)? (e:any) => handleDeleteRol(e,data) : () => {warning("No tienes permisos para realizar esta operación")}  : () => {warning("No tienes permisos para realizar esta operación")}}/>  
            </button>
        )
    }

    const cellPlantsRenderer = (params:any) => {
        const { id_plants } = params.data

        if(id_plants.length === 0) {
            return " - "
        } else {
            const nombres:any = {
                1: 'Sanguesa',
                2: 'Briviesca',
                3: 'Miajadas',
              }
            const nombresSeleccionados = params.data.id_plants.map((id:any) => nombres[id])
            return nombresSeleccionados.join(', ')
        }
        
    }

    const handleCellStyle = () => {
        return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6',fontFamily:'var(--roboto-medium)'}
         
    }


    return (
        <div className="ag-theme-alpine" style={{display:'flex',flexDirection:'column', height:'85%', width: '95%' }}>

            <AgGridReact
                ref={gridRef}
                headerHeight={30}
                getRowHeight={() => 30}
                rowData={dataTable}
                enableCellTextSelection>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} resizable={true} flex={1} hide  field={"id"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  suppressNavigable={true} sortable  resizable={true} flex={1} headerName={"User ID"} field={"id_user"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} sortable  suppressNavigable={true}  resizable={true} flex={1} headerName={"Email"} field={"email"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  suppressNavigable={true} sortable  resizable={true} flex={1} headerName={"Usuario"} field={"name_user"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  suppressNavigable={true} sortable  resizable={true} flex={1} headerName={"Rol"} field={"name_rol"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} cellRenderer={cellPlantsRenderer}  suppressNavigable={true} sortable  resizable={true} flex={1} headerName={"Plantas asociadas"} field={"id_plants"}></AgGridColumn>
                <AgGridColumn  headerName={"Acciones"} headerClass={"header-resize"} flex={0.75} cellRenderer={LinkCellRenderer}></AgGridColumn>

            </AgGridReact>
        </div>
    )
}